import FactorIconContainer from './factor_icon_container';

const FactorIcon = FactorIconContainer;
export default FactorIcon;
